import { useEffect, useState } from "react";

export default function InputNumber({ name, id, value, placeholder, input }) {
  const [innerValue, setValue] = useState(parseInt(input?.value ? input.value : value ? value : placeholder));

  function onChange(value)
  {
    value = parseInt(value)
    if(value >= 0) {
      input.onChange(value)
      setValue(value)
    }
  }

  return (
    <div className={"flex w-full justify-center"}>
      <div className=" mt-3 flex items-center gap-4 text-2xl text-gray-900">
        <div
          className={"text-3xl hover:cursor-pointer"}
          onClick={() => onChange(parseInt(innerValue) - 1)}
        >
          -
        </div>
        <div className={"w-[50px] border-b-2 border-orange-500"}>
          <input
            autoComplete="off"
            type="text"
            name={name}
            value={innerValue}
            onChange={(e) => onChange(e.target.value)}
            id={id}
            placeholder={"1"}
            className="block w-full border-none text-center text-2xl focus:border-none focus:outline-none focus:ring-0"
          />
        </div>
        <div
          className={"text-3xl hover:cursor-pointer"}
          onClick={() => onChange(parseInt(innerValue) + 1)}
        >
          +
        </div>
      </div>
    </div>
  );
}
